import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Button, Row, Col, Table, Modal, ModalFooter, ModalBody, ModalHeader } from "reactstrap"
import { Download, Share, Edit, Trash } from "react-feather";
import Chip from "../../theme/@vuexy/chips/ChipComponent";
import PillActiveBorder from "../elements/tabPills";
import LibraryCarousel from "./components/libraryCarousel";
import ContentPreview from "../elements/contentPreview";
import classnames from "classnames"
import PerfectScrollbar from "react-perfect-scrollbar";
import "../../assets/scss/pages/data-list.scss";
import { inject, observer } from 'mobx-react';
import ContentActivities from "../common/elements/contentActivity";
import processingImg from '../../assets/img/pages/maintenance.png'

@inject('libraryStore')
@observer
class ViewContent extends Component {

  state = {
    previewData: [],
    deleteModal: false
  }

 /* componentDidUpdate = prevProps => {
    const { pages } = this.props.libraryStore.document;
    if (pages) {
      if (prevProps.libraryStore.document.file.pages !== this.state.previewData) {
        this.setState({
          previewData: prevProps.libraryStore.document.file.pages
        })
      }
    }
  }
  */

  details = () => {
    const { libraryStore } = this.props;
    const {
      uid,
      category,
      contentType,
      shareable,
      isActive,
      readTime,
      customerStage,
      coverTemplate
    } = libraryStore.document;
    return (

      <Table borderless style={{ width: "100%" }}>
        <tbody className="_detail">
          <tr>
            <th scope="row">
              <span>Content Type:</span>
            </th>
            <td>
              {
                contentType
                  ? <span className="text-capitalize">{contentType}</span>
                  : <span>--NA--</span>
              }
            </td>
          </tr>
          <tr>
            <th>
              <span>Category:</span>
            </th>
            <td>
              {
                category
                  ? <span className="text-capitalize">{category}</span>
                  : <span>--NA--</span>
              }
            </td>
          </tr>
          <tr>
            <th scope="row">
              <span>Template:</span>
            </th>
            <td>
              {
                coverTemplate && coverTemplate.title
                  ? <span className="text-capitalize">{coverTemplate.title}</span>
                  : <span>--NA--</span>
              }
            </td>
          </tr>
          
          <tr>
            <th>
              <span>Customer Level:</span>
            </th>
            <td>
              {
                customerStage
                  ? <span>{customerStage}</span>
                  : <span>--NA--</span>
              }
            </td>
          </tr>
          <tr>
            <th>
              <span>Status:</span>
            </th>
            <td>
              <span className="text-capitalize">{isActive}</span>
            </td>
          </tr>
          <tr>
            <th>
              <span>Shareable:</span>
            </th>
            <td>
              <span>{shareable ? "Yes" : "No"}</span>
            </td>
          </tr>
          <tr>
            <th>
              <span>Read Time:</span>
            </th>
            <td>
              {
                readTime
                  ? <span> {readTime} mins</span>
                  : <span>--NA--</span>
              }
            </td>
          </tr>
        </tbody>
      </Table>
    );
  }

  activity = () => {
    const { libraryStore } = this.props;
    const { activityCollection } = libraryStore;
    const { activities } = activityCollection;
    return (
      <ContentActivities activities={activities} />
    )
  }

  analytics = () => {
    return (
      <p>Nothing to show yet...</p>
    )
  }

  toggleDeleteModal = () => {
    this.setState({
      deleteModal: !this.state.deleteModal
    })
  }

  removeContent = () => {
    const { libraryStore } = this.props;
    libraryStore.removeDocument();
    this.toggleDeleteModal();
    this.props.closePage();
  }



  renderDetails = () => {
    const { libraryStore } = this.props;
    const {
      description,
      tags,
      file,
      contentType
    } = libraryStore.document;
    const { docUrl,
      pages,
      size,
      noOfPages,
      fileName,
      conversionStatus} = file;
    const previewData  = pages || [];
    
    return (
      <Row>
        <Col xs={12} md={6} lg={8} >
          <div >
            {pages && pages.length && conversionStatus == "COMPLETED"
              ? <LibraryCarousel
                data={previewData}
                docUrl={docUrl}
                height="300px"
                size={size}
                showDownloadButton={true}
                showThumbnailButton={false}
                overlayControls={true}
                contentType={contentType}
                fileName={fileName} 
              />
              : <div className="d-flex flex-column align-items-center justify-content-center theme-bg-img" style={{ height: "500px", border: "2px dashed #eee" }}>
                {/* <p className="mt-1 " style={{ color: "#cacaca", fontWeight: '700' }}>No Files Added</p> */}
                <img
                  className="img-fluid overflow-hidden-preview-img"
                  src={processingImg}
                  alt={"processing"}
                />
                <span>
                  <h2 className="centered">Processing...</h2>
                </span>
              </div>
            }
          </div>
          <div className="mb-2 mt-3">
            <h4 className="heading mb-1">Tags</h4>
            <div className="ml-1">
              {
                tags && tags.length ?
                  tags.map((item, index) => {
                    return (
                      <Chip color="primary" className=" mr-1" key={index} text={item} />
                    )
                  })
                  : <p>No Tags are associated with this post.</p>
              }
            </div>
          </div>
          <div className="mb-2 mt-3">
            <h4 className="heading"> Description</h4>
            {
              description
                ? <p className="ml-1">{description}</p>
                : <p className="ml-1">Description not provided.</p>
            }
          </div>
        </Col>
        <Col xs={12} md={6} lg={4} >
          <PillActiveBorder
            tabsContent={[
              {
                key: '1',
                tab_name: "Details",
                tab_content: this.details()
              },
              {
                key: '2',
                tab_name: "Activity",
                tab_content: this.activity()
              },
              {
                key: '3',
                tab_name: "Analytics",
                tab_content: this.analytics()
              }
            ]}
          />
        </Col>
      </Row>
    );
  }

  onEdit = (uid) => {
    this.props.editContent(uid);
  }

  onShare = () =>{
    this.props.openSharePage();
  }

  render() {
    let { show, closePage } = this.props;
    const { libraryStore } = this.props;
    const { name, uid } = libraryStore.document;
    
    return (
      <div
        className={classnames("view-content-sidebar", {
          show: show
        })}>
        <PerfectScrollbar options={{ wheelPropagation: false }}>
          <div className="library-content-view">
            <div className="content-view-header flex-wrap">
              <h3 className="textCapitalize">{name}</h3>
              <div>
                {
                  !this.props.editContent
                    ? null
                    : <Button color="primary" onClick={(e)=> this.onEdit(uid)}>
                      <Edit size="15" />Edit
                  </Button>
                }
                {
                  !this.props.openSharePage
                    ? null
                    : <Button className="ml-1" color="danger" onClick={this.toggleDeleteModal}>
                      <Trash size="15" />Delete
                  </Button>
                }
                {
                  !this.props.openSharePage
                    ? null
                    : <Button className="ml-1" color="primary" outline onClick={(e) => this.onShare()}>
                      <Share size="15" />Share
                </Button>
                }
                <Button
                  className="ml-1"
                  color="danger"
                  outline
                  onClick={closePage}>
                  Cancel
              </Button>
              </div>
            </div>
            <div className="content-details">
              {this.renderDetails()}
            </div>
          </div>
        </PerfectScrollbar>

        <div>
          <Modal isOpen={this.state.deleteModal} toggle={this.toggleDeleteModal}>
            <ModalHeader>
              Delete Content
            </ModalHeader>
            <ModalBody>
              <h5>This action is permanent !</h5>
              <p> Are you sure you want to remove this content.</p>
            </ModalBody>
            <ModalFooter>
              <Button color="danger" outline onClick={this.toggleDeleteModal}>Cancel</Button>
              <Button color="primary" onClick={() => this.removeContent()}>Delete</Button>{' '}
            </ModalFooter>
          </Modal>
        </div>

      </div>
    );
  }
}

export default withRouter(ViewContent);
